import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=d5635b2a&scoped=true&"
import script from "./Languages.vue?vue&type=script&lang=ts&"
export * from "./Languages.vue?vue&type=script&lang=ts&"
import style0 from "./Languages.vue?vue&type=style&index=0&id=d5635b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5635b2a",
  null
  
)

export default component.exports